import { render, staticRenderFns } from "./layout-breadcrumb.vue?vue&type=template&id=3b4f3812"
import script from "./layout-breadcrumb.vue?vue&type=script&lang=js"
export * from "./layout-breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports